import { Category } from "../types";

const categories: Category[] = ["toy", "clothing", "consumable", "home"];

export type ValidationResult = {
  valid: boolean;
  errors: string[];
};

const isValidHttpUrl = (value: string) => {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export function sanitizeReferences(raw: string): string[] {
  return raw
    .split(/\n+/)
    .map((value) => value.trim())
    .filter((value) => Boolean(value));
}

export function validateItemPayload(payload: {
  name: string;
  category: string;
  url?: string;
  urls?: string[];
  description?: string;
  quantity: number;
  got: boolean;
  reference: string[];
}): ValidationResult {
  const errors: string[] = [];

  if (!categories.includes(payload.category as Category)) {
    errors.push("Category must be toy, clothing, consumable, or home");
  }
  if (!payload.name.trim() || payload.name.trim().length > 256) {
    errors.push("Name must be between 1 and 256 characters");
  }
  if (payload.description && payload.description.length > 16384) {
    errors.push("Description cannot be longer than 16384 characters");
  }
  const urls = Array.isArray(payload.urls) ? payload.urls : [];
  if (payload.url) {
    const trimmed = payload.url.trim();
    if (!trimmed || trimmed.length > 1024) {
      errors.push("URL must be between 1 and 1024 characters");
    } else if (!isValidHttpUrl(trimmed)) {
      errors.push("URL must be a valid http(s) link");
    }
  }
  urls.forEach((link, index) => {
    const trimmed = link.trim();
    if (trimmed.length === 0) return;
    if (trimmed.length > 1024 || !isValidHttpUrl(trimmed)) {
      errors.push(`URL ${index + 1} must be a valid http(s) link under 1024 characters`);
    }
  });
  if ((payload.url === undefined || payload.url.trim() === "") && urls.length === 0) {
    // Allow zero URLs only if both url and urls absent? requirement says allow zero or more.
    // So do not add error; only ensure provided values are valid.
  }
  if (Number.isNaN(payload.quantity) || payload.quantity < 0) {
    errors.push("Quantity must be a positive number");
  }
  if (typeof payload.got !== "boolean") {
    errors.push("Got must be a boolean");
  }
  if (!Array.isArray(payload.reference)) {
    errors.push("References must be an array");
  } else {
    payload.reference.forEach((ref, index) => {
      const trimmed = ref.trim();
      if (!trimmed || trimmed.length > 1024 || !isValidHttpUrl(trimmed)) {
        errors.push(`Reference ${index + 1} must be a valid http(s) link under 1024 characters`);
      }
    });
  }

  return { valid: errors.length === 0, errors };
}
